import { requestApi } from "./axiosHelper"

const rootUrl = process.env.REACT_APP_API_ROOT_URL
const studentURL = rootUrl + "/student"

export const createAccStudents = async (enrolment) => {
  try {
    const axiosData = {
      url: studentURL,
      method: "post",
      data: enrolment,
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)
    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}

export const fetchAllStudents = async (_id) => {
  try {
    const axiosData = {
      url: _id ? `${studentURL}/${_id}` : studentURL,
      method: "get",
      body: null,
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)
    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}
